"use strict";
import UmamiApiClient from "./UmamiApiClient";
export default UmamiApiClient;
